import { useMedia } from "react-use";

import { VIEWPORT_TABLET } from "../lib";

export const useIsDesktopViewport = () =>
  useMedia(`(min-width: ${VIEWPORT_TABLET}px)`, false);
